<template>
<div class="upload-button-item"
  v-loading="loading">
  <div v-if="$deviceLib.isOnline">
    <label id="upload-photo-button"
           for="upload-photo">
    <i class="el-icon-picture"></i> 写真をアップロードする
    <input @change="selectedFile"
           type="file"
           name="upload-photo"
           id="upload-photo"
           style="display:none;"
           accept="image/*">
    </label>
    <div v-if="errorMessage"
      class="error-message">{{ errorMessage }}
    </div>
  </div>
  <div v-else
    class="error-message">
    現在オフラインのためアップロードはご利用頂けません。ネットワークに繋げてからお試しください。
  </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      imageSrc: '',
      uploadFile: null,
      nowLoading: false,
      errorMessage: '',
      loading: false
    }
  },
  methods: {
    selectedFile: function (e) {
      e.preventDefault()
      const files = e.target.files
      this.uploadFile = files[0]
      this.upload()
    },
    upload: function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      // FormData を利用して File を POST する
      let formData = new FormData()
      const app = this
      formData.append('image', this.uploadFile)
      let config = {
        headers: {
          'content-type': 'multipart/form-data'
        },
        timeout: 40000
      }
      this.loading = true
      this.$axios
        .post(this.$varuna.endPoints.imageUpload, formData, config)
        .then(function (response) {
          app.imageSrc = response.data
          app.errorMessage = ''
        })
        .catch(function (error) {
          console.error(error)
          app.$gtm.sendError('upload photo', error)
          app.errorMessage = 'アップロードに失敗しました'
        })
        .finally(function () {
          app.loading = false
        })
    }
  },
  watch: {
    imageSrc: {
      handler: function (newVal, oldVal) {
        this.$emit('upload-photo-complete', newVal)
      }
    }
  }
}
</script>
